import React from "react";
import GridShape from "../../components/common/GridShape";
import { Link } from "react-router";
import ThemeTogglerTwo from "../../components/common/ThemeTogglerTwo";
import { useConfig } from "../../context/ConfigContext";

export default function AuthLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const { nomeApp, faviconPath } = useConfig();
  return (
    <div className="relative p-6 bg-white z-1 dark:bg-gray-900 sm:p-0">
      <div className="relative flex flex-col justify-center w-full h-screen lg:flex-row dark:bg-gray-900 sm:p-0">
        {children}
        <div className="items-center hidden w-full h-full lg:w-1/2 bg-brand-950 dark:bg-white/5 lg:grid">
          <div className="relative flex items-center justify-center z-1">
            {/* <!-- ===== Common Grid Shape Start ===== --> */}
            <GridShape />
            <div className="flex flex-col items-center max-w-xs text-center">
              {faviconPath ? (
                <div className="mb-6 p-4 bg-white/10 dark:bg-white/5 rounded-2xl backdrop-blur-md border border-white/20 shadow-xl">
                  <img
                    src={faviconPath}
                    alt={nomeApp}
                    className="h-24 w-24 object-contain rounded-xl"
                  />
                </div>
              ) : (
                <div className="mb-6 flex items-center justify-center h-24 w-24 rounded-2xl bg-white/10 text-white font-bold text-5xl backdrop-blur-md border border-white/20 shadow-xl">
                  {nomeApp.slice(0, 1)}
                </div>
              )}
              <Link to="/dashboard" className="mb-4 block text-4xl font-extrabold tracking-tight text-white">
                {nomeApp}
              </Link>
              <p className="text-center text-gray-300 dark:text-white/60 font-medium">
                Painel de acompanhamento de campanha eleitoral
              </p>
            </div>
          </div>
        </div>
        <div className="fixed z-50 hidden bottom-6 right-6 sm:block">
          <ThemeTogglerTwo />
        </div>
      </div>
    </div>
  );
}
